<template>
    <div class="col-12">
        <div class="product_tabs" v-if="description || tabs.length" id="proTabs">
            <a
                href="javascript:"
                v-if="description"
                class="product_tabs_link"
                v-on:click="setActive('tab_description')"
                :class="{active: isActive('tab_description')}"
            >Description</a>
            <a
                href="javascript:"
                v-if="Object.keys(attributesTab).length"
                class="product_tabs_link"
                v-on:click="setActive('tab_attribute')"
                :class="{active: isActive('tab_attribute')}"
            >Additional information</a>
            <a
                v-for="tab in tabs"
                href="javascript:"
                v-if="tab && tab.title"
                class="product_tabs_link"
                v-on:click="setActive(`#tab_${tab.id}${tab.tab_id ? `_${tab.tab_id}` : '' }`)"
                :class="{active: isActive(`#tab_${tab.id}${tab.tab_id ? `_${tab.tab_id}` : '' }`)}"
            >{{ tab.title }}</a>
        </div>
        <div class="product_tabs_content">
            <div class="tab-pane product-tab-content product-description" v-if="description" :class="{active: isActive('tab_description')}">
                <h2>Description</h2>
                <div v-html="description"></div>
            </div>

            <div class="tab-pane product-tab-content" v-if="Object.keys(attributesTab).length" :class="{active: isActive('tab_attribute')}">
                <h2>Additional information</h2>
                <div  v-for="key in Object.keys(attributesTab)">
                    <span>{{key}}</span>
                    <span>{{attributesTab[key]}}</span>
                </div>
            </div>

            <div :id="'tab_'+tab.id " v-for="tab in tabs" v-if="tab && tab.title" class="tab-pane product-tab-content" :class="{active: isActive(`#tab_${tab.id}${tab.tab_id ? `_${tab.tab_id}` : '' }`)}">
                <h2>{{ tab.title }}</h2>
                <div v-if="tab.additional_content" v-html="tab.additional_content"></div>
                <div v-html="tab.content"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'product-tabs',
    props: ['propDescription', 'propProductId', 'propAttributesTab', 'propPreview'],
    data() {
      return {
          tabs: [],
          activeTab: '',
          isPreview: this.propPreview
      }
    },
    mounted() {

        this.getTabs();
        this.calcBtnWidth();

        this.$nextTick(() => {
            const images = document.querySelectorAll('.data_fancy_box_fix img:not(.not-fancy)');
                images.forEach(image => {
                    if (!image.getAttribute('data-fancybox')) {
                        image.setAttribute('data-fancybox','');
                    }
            });

            $('.data_fancy_box_fix img[data-fancybox]').each(function() {
                var $img = $(this);
                var thumbSrc = $img.attr('src');
                var imgAlt = $img.attr('alt');
                var fullSrc = thumbSrc.replace(/-\d+x\d+\./, '.');
                if (fullSrc !== thumbSrc) {
                    $img.wrap($('<a>', {
                        href: fullSrc,
                        class: 'fancybox'
                    }));
                    $img.attr('data-src', fullSrc);
                }
                if($img.parents('.init-flickity[data-main="carousel-product-nav"]').length)
                {
                    $img.attr('data-caption', imgAlt);
                }
            });

            $('img[data-fancybox]').each(function() {
                var $img = $(this);
                var thumbSrc = $img.attr('src');
                var fullSrc = thumbSrc.replace(/-\d+x\d+\./, '.');
                $img.attr('data-src', fullSrc);
            });
        });
    },
    updated() {
        $('body .init-flickity').show()
        $('body .init-flickity-nav').show()

        let elements = document.querySelectorAll('.init-flickity');

        elements.forEach(el => {

                new Flickity( el, this.constants.MAIN_FLICKITY_OPTIONS).resize()
        })
        const totalWidthMap = {};
        const flickityArr = [];
        elements = document.querySelectorAll('.product_slider.single-gallery-slider .init-flickity-nav');
        elements.forEach(el => {
            flickityArr.push(new Flickity( el, {
                asNavFor: '#' + el.getAttribute('data-main'),
                contain: true,
                pageDots: false,
                 arrowClickAttraction: 0,
                // selectedAttraction: 0.1, // Set attraction to a non-zero value for other events
                // friction: 0.2, // Set friction to a non-zero value for other events

            }));
            const galleryId = el.getAttribute('data-main');
            const flickityInstanceNav = flickityArr.find(flickity => flickity.element === el);

            const renderWidth = $(el).find('.flickity-viewport').width();
            let scrollThumbWidth = 0;
            let totalWidthNav = 0;

            if (flickityInstanceNav) {
            flickityInstanceNav.slides.forEach(slide => {
                totalWidthNav += slide.outerWidth;
            });

            totalWidthMap[galleryId] = totalWidthNav;
            }

            scrollThumbWidth = renderWidth / totalWidthNav * renderWidth;

            if (scrollThumbWidth > renderWidth) {
                $(el).siblings(".scroll_nav").hide();
            } else {
                $(el).parent('.gallery-carousel').find(".scroll_nav").show();
                $(el).parent('.gallery-carousel').find(".scroll_nav").css("max-width", renderWidth);
                $(el).parent('.gallery-carousel').find(".scroll_nav .scroll_indicator").css("width", scrollThumbWidth);

                const scrollIndicator = $(el).parent('.gallery-carousel').find('.scroll_nav .scroll_indicator')[0];

                const draggie = new Draggabilly(scrollIndicator, {
                    axis: 'x',
                });

                draggie.on('dragStart', function() {
                    dragScroll();
                });
                draggie.on('dragEnd', function() {
                    dragScroll();
                });
                // draggie.on('pointerDown', function() {
                //     dragScroll();
                // });
                // draggie.on('pointerUp', function() {
                //     dragScroll();
                // });
                draggie.on('dragMove', function (event, pointer, moveVector) {
                    // Check if cellSelect event is active, disable drag during cellSelect
                    dragScroll();
                });

                function dragScroll()
                {
                    if (!flickityInstanceNav.cellSelecting) {
                        const totalSlides = flickityInstanceNav.slides.length;
                        const maxPositionDrag = renderWidth - scrollThumbWidth;
                        const newPosition = Math.max(0, Math.min(draggie.position.x, maxPositionDrag));
                        const progress = newPosition / maxPositionDrag;
                        const newIndex = Math.round(progress * (totalSlides - 1));
                        const totalScrollWidth = $(el).siblings(".scroll_nav").width();
                        flickityInstanceNav.select(newIndex);

                        // Ensure the new position is within the bounds of the scrollNav


                        const maxPositionScroll = totalScrollWidth - scrollThumbWidth;

                        let constrainedPosition = Math.max(0, Math.min(draggie.position.x, maxPositionScroll));

                        constrainedPosition = constrainedPosition >= 1 ? constrainedPosition : 0;
                        // Update the custom scrollbar position using left
                        $(el).siblings(".scroll_nav").find('.scroll_indicator').css('left', constrainedPosition + 'px');
                    }
                }
            }

               // Update the custom scrollbar position on arrow click
            $('.product_slider.single-gallery-slider .init-flickity-nav .flickity-prev-next-button').on('click', function() {
                const currentIndex = flickityInstanceNav.selectedIndex;
                const totalSlides = flickityInstanceNav.slides.length;
                const progress = currentIndex / (totalSlides - 1);
                const scrollWidth = $(el).siblings(".scroll_nav").width() - $(el).siblings(".scroll_nav").find('.scroll_indicator').width();
                const newPosition = scrollWidth * progress;

                // Update the custom scrollbar position using left
                $(el).siblings(".scroll_nav").find('.scroll_indicator').css('left', newPosition + 'px');
            });

            // Update the custom scrollbar position on cell select
            flickityInstanceNav.on('cellSelect', function () {
                const selectedIndex = flickityInstanceNav.selectedIndex;

                // Calculate the new position based on the selected index
                const scrollThumbWidth = $(el).siblings(".scroll_nav").find('.scroll_indicator').width();
                const totalSlides = flickityInstanceNav.slides.length;
                const newPosition = Math.max(0, Math.min(renderWidth - scrollThumbWidth, renderWidth * selectedIndex / (totalSlides - 1) - scrollThumbWidth / 2));

                // Update the custom scrollbar position using left
                $(el).siblings(".scroll_nav").find('.scroll_indicator').css('left', newPosition + 'px');
            });
        })
        flickityArr.forEach(i => {
            i.resize();
        });
        const navBtns = document.querySelectorAll('body .init-flickity .flickity-button-icon')
        const navBtnNext = document.querySelectorAll('body .init-flickity .flickity-prev-next-button.next svg path')
        navBtns.forEach(el => {
            el.setAttribute('viewBox', '0 0 512 512')
        })
        navBtnNext.forEach(el => {
            el.setAttribute('transform', 'translate(0, 0) rotate(180)')
            el.setAttribute('transform-origin', 'center')
        })
        $('.image-carousel').each(function (element, index) {
            $(this).attr('src', $(this).attr('data-large'))
        })

        Fancybox.bind("[data-fancybox]");

        this.calcBtnWidth();

        let fancyImage = $('body .product-tab-content').find('.ezcol').find('a img.image_shadow');
        fancyImage.each(function () {
            let fancyImageLink = $(this).parent('a').attr('href');
            $(this).attr('src', fancyImageLink)
        })

        $('img[data-fancybox]').each(function() {
            var $img = $(this);
            var thumbSrc = $img.attr('src');
            var fullSrc = thumbSrc.replace(/-\d+x\d+\./, '.');
            $img.attr('data-src', fullSrc);
        });

        // let howToInstallImage = $('body .product-tab-content').find('a').find('img').attr('title', 'how to install a coffered ceiling');
        // let howToInstallImage = $('body .product-tab-content').find('a').find('img');
        // if(howToInstallImage) {
        //     howToInstallImage.each(function () {
        //         let howToInstallLink = $(this).parent('a').attr('href');
        //         if (howToInstallLink.indexOf(".jpg") >= 0 || howToInstallLink.indexOf(".png") >= 0 || howToInstallLink.indexOf(".jpeg") >= 0) {
        //             $(this).attr('src', howToInstallLink)
        //         }
        //     })
        // }

    },
    computed: {
        description() {
            return this.propDescription || null
        },
        attributesTab() {
            return this.propAttributesTab || {}
        },
    },
    methods: {

        async getTabs() {
            const {data} = await axios.get(`${_configs.baseUrl}/product-tab/${this.propProductId}?preview=${this.isPreview}`);
            this.tabs = (data && data.tabs) || [];
            this.setActive(this.propDescription ?  `tab_description` : (this.tabs.length ? `tab_${this.tabs[0].id}` : ''));
        },
        isActive(current) {
            return current === this.activeTab
        },
        setActive(current) {
            this.activeTab = current
        },
        calcBtnWidth() {
            let orderSamplesBtn = Array.from($('body .product-content  .imghvr_indent a:not(.phone_link)'));
            let orderSamplesBtn01 = Array.from($('body .short_description  .imghvr_indent a:not(.phone_link)'));
            let btnWidthArray = [];
            if(orderSamplesBtn.length > 1) {
                for(let i = 0; i < orderSamplesBtn.length; i++) {
                    let btnWidth = ($(orderSamplesBtn[i]).width());
                    btnWidthArray.push(btnWidth)
                }
                for(let i = 0; i < orderSamplesBtn.length; i++) {
                    let btnMax = Math.max.apply(Math, btnWidthArray)
                    $(orderSamplesBtn[i]).attr("style", 'min-width:' + (btnMax + 36) + 'px')
                }
            }
            let btnWidthArray02 = [];
            if(orderSamplesBtn01.length > 1) {
                for(let i = 0; i < orderSamplesBtn01.length; i++) {
                    let btnWidth02 = ($(orderSamplesBtn01[i]).width());
                    btnWidthArray02.push(btnWidth02)
                }
                for(let i = 0; i < orderSamplesBtn01.length; i++) {
                    let btnMax02 = Math.max.apply(Math, btnWidthArray02)
                    $(orderSamplesBtn01[i]).attr("style", 'min-width:' + (btnMax02 + 36) + 'px')
                }
            }
        },
    }
}
</script>
